import React, { useState } from 'react';
import { elementClasses } from '../../../utils/utils';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { useTranslation } from 'react-i18next';
import MockTestList from './mock-test-list';
import { MOCK_TEST_TYPE } from '@app/constants/mockTest';

export const MockTestPage: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(MOCK_TEST_TYPE.FULL_TEST);
  const tabs = [
    { name: t('page.mockTest.allMockTest'), key: MOCK_TEST_TYPE.FULL_TEST, href: '#' },
    { name: t('page.mockTest.pteAcademic'), key: MOCK_TEST_TYPE.SECTION_TEST, href: '#' },
    { name: t('page.mockTest.pteCore'), key: MOCK_TEST_TYPE.QUESTION_TEST, href: '#' },
  ];

  return (
    <>
      <PageTitle>{t('common.mock-tests')}</PageTitle>
      <div className="flex min-h-screen gap-10 bg-[#f9f9f9] px-8 pt-8" style={{ width: '1040px', margin: 'auto' }}>
        <div className="flex flex-1 flex-col gap-3">
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <div className="shadow-xs flex flex-col rounded-lg bg-white p-8">
                <h1 className={elementClasses('text-lg font-semibold leading-8')}>{t('common.mock-tests')}</h1>
                <label className="mt-5 text-sm font-medium text-gray-600" htmlFor="voucher">
                  {t('page.mockTest.description')}
                </label>
                <div className="py-4  text-sm font-medium text-gray-600">
                  <h3 className="mb-2 font-bold">{t('page.mockTest.communicativeScores')}:</h3>
                  <div className="-mx-2 mb-4 flex flex-wrap">
                    <div className="w-1/2 px-2">
                      <ul className="list-disc pl-5">
                        <li>{t('common.speaking')}</li>
                        <li>{t('common.reading')}</li>
                      </ul>
                    </div>
                    <div className="w-1/2 px-2">
                      <ul className="list-disc pl-5">
                        <li>{t('common.writing')}</li>
                        <li>{t('common.listening')}</li>
                      </ul>
                    </div>
                  </div>
                  <h3 className="mb-2 font-bold">{t('page.mockTest.enablingScores')}:</h3>
                  <div className="-mx-2 flex flex-wrap">
                    <div className="w-1/2 px-2">
                      <ul className="list-disc pl-5">
                        <li>{t('page.mockTest.grammar')}</li>
                        <li>{t('page.mockTest.fluency')}</li>
                        <li>{t('page.mockTest.writtenDiscourse')}</li>
                      </ul>
                    </div>
                    <div className="w-1/2 px-2">
                      <ul className="list-disc pl-5">
                        <li>{t('page.mockTest.pronunciation')}</li>
                        <li>{t('page.mockTest.vocabulary')}</li>
                        <li>{t('page.mockTest.spelling')}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  {/* <div className="sm:hidden">
                    <label htmlFor="tabs" className="sr-only">
                      Select a tab
                    </label>
                    <select
                      id="tabs"
                      name="tabs"
                      className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
                      defaultValue={tabs.find((tab) => tab.current)?.name ?? ''}
                    >
                      {tabs.map((tab) => (
                        <option key={tab.name}>{tab.name}</option>
                      ))}
                    </select>
                  </div> */}
                  <div className="hidden sm:block">
                    <div className="border-b border-gray-200">
                      <nav className="-mb-px flex" aria-label="Tabs">
                        {tabs.map((tab) => (
                          <a
                            key={tab.key}
                            href={tab.href}
                            onClick={(e) => {
                              e.preventDefault();
                              setActiveTab(tab.key);
                            }}
                            className={elementClasses(
                              activeTab === tab.key
                                ? 'border-[#ffc92b] text-black'
                                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                              'w-full border-b-2 px-1 py-4 text-center text-base font-semibold',
                            )}
                            aria-current={activeTab === tab.key ? 'page' : undefined}
                          >
                            {tab.name}
                          </a>
                        ))}
                      </nav>
                    </div>
                  </div>
                </div>
                <div className=" rounded-lg bg-white p-4">
                  <MockTestList type={activeTab} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
